import { render, staticRenderFns } from "./CustomersTurnover.vue?vue&type=template&id=5b4dd3bf"
import script from "./CustomersTurnover.vue?vue&type=script&lang=js"
export * from "./CustomersTurnover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports